import { CesiumCollectionContextProvider } from 'app/agriculture/contexts/CesiumCollectionContextProvider';
import { MapVisibilityContextProvider } from 'app/agriculture/contexts/MapVisibilityContextProvider';
import { MapModeContextProvider } from 'app/agriculture/contexts/MapModeContextProvider';
import { DraggingHerdContextProvider } from 'app/agriculture/contexts/DraggingContextProvider';
import { TerrainModeProvider } from 'app/agriculture/contexts/TerrainProviderContext';
import { TerrainProviderContextProvider } from './TerrainContextProvider';

export function MapProviders({ children }: { children: React.ReactNode }) {
    return (
        <TerrainModeProvider>
            <TerrainProviderContextProvider>
                <CesiumCollectionContextProvider>
                    <DraggingHerdContextProvider>
                        <MapVisibilityContextProvider>
                            <MapModeContextProvider>{children}</MapModeContextProvider>
                        </MapVisibilityContextProvider>
                    </DraggingHerdContextProvider>
                </CesiumCollectionContextProvider>
            </TerrainProviderContextProvider>
        </TerrainModeProvider>
    );
}
